jQuery(function($) {
    // Config from wp_localize_script
    const config = window.PifFilterConfig || {};
    const taxonomies = config.taxonomies || [];
    const acfFilters = config.acfFilters || [];
    const listClass = '.filtered-posts__list';
    const sidebarClass = '.filtered-posts__sidebar';
    const ajax_url = config.ajax_url || '';
    const ajaxAction = config.ajax_action || '';
    const $sortSelect = $( '#filtered-posts-sort' );
    const defaultSort = 'az';

    // Helper: get current filters as an object
    function getFilters() {
        let data = {};
        // Taxonomies
        taxonomies.forEach(tax => {
            data[tax] = [];
            $(`input[type=checkbox][data-taxonomy=${tax}]:checked`).each(function() {
                data[tax].push($(this).val());
            });
        });
        // ACF select fields
        acfFilters.forEach(acf => {
            data[acf] = [];
            $(`input[type=checkbox][data-taxonomy=${acf}]:checked`).each(function() {
                data[acf].push($(this).val());
            });
        });
        // Keyword
        data['keyword'] = $('.keyword-filter-search-field').val();
        // Sort order (only on pages that have the sort select)
        if ( $sortSelect.length ) {
            data['sort'] = $sortSelect.val() || defaultSort;
        }
        // Pagination
        data['paged'] = $('.pagination-link .current').text() || 1;
        return data;
    }

    // Helper: set filters from URL params
    function setFiltersFromURL() {
        const params = new URLSearchParams(window.location.search);
        // Taxonomies
        taxonomies.concat(acfFilters).forEach(tax => {
            let vals = params.getAll(tax + '[]');
            if (!vals.length && params.get(tax)) {
                vals = params.get(tax).split(',');
            }
            vals.forEach(val => {
                $(`input[type=checkbox][data-taxonomy=${tax}][value="${val}"]`).prop('checked', true);
            });
        });
        // Keyword
        if (params.get('keyword')) {
            $('.keyword-filter-search-field').val(params.get('keyword'));
        }
        // Sort order (ignore values that aren't one of the select's options)
        const sort = params.get( 'sort' );
        if ( sort && $sortSelect.find( `option[value="${sort}"]` ).length ) {
            $sortSelect.val( sort );
        }
    }

    // Helper: update URL with current filters
    function updateURL(filters) {
        const params = new URLSearchParams();
        taxonomies.concat(acfFilters).forEach(tax => {
            if (filters[tax] && filters[tax].length) {
                filters[tax].forEach(val => params.append(tax + '[]', val));
            }
        });
        if (filters.keyword) params.set('keyword', filters.keyword);
        if ( filters.sort && filters.sort !== defaultSort ) params.set( 'sort', filters.sort );
        const newurl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.history.replaceState({}, '', newurl);
    }

    // AJAX update
    function updateResources(paged = 1, updateUrl = true) {
        let data = getFilters();
        data['paged'] = paged;
        if (updateUrl) updateURL(data);

        // Show loading state / placeholder
        var $wrapper = $('.filtered-posts__list-wrapper');
        $wrapper.addClass('loading');

        $.post(ajax_url, {
            action: ajaxAction,
            nonce: window.PifFilterConfig && window.PifFilterConfig.filter_nonce ? window.PifFilterConfig.filter_nonce : '',
            ...data
        }, function(response) {
            
            if (response.success === false) {
                if (response.data && response.data.message && response.data.message == 'You must be logged in to view webinars.') {
                    $('.filtered-posts__sidebar-wrapper .member-only-login-prompt').removeClass('d-none');
                    $('.filtered-posts__list-wrapper .filtered-posts__list').addClass('d-none');
                } else {
                    $(listClass).html(response.data.message);
                }
                $wrapper.removeClass('loading');
            } else {
                $(listClass).html(response.cards_html);
                if (response.pagination) {
                    $(listClass).append(`<div class="pagination filtered-posts__list-pagination justify-content-center">${response.pagination}</div>`);
                }
                // Only show count if filters are active
                if (response.filters_active && response.total > 0) {
                    $('.filtered-posts__active-filters-count').text(`${response.total} results`).removeClass('d-none');
                } else {
                    $('.filtered-posts__active-filters-count').addClass('d-none');
                }
                // Scroll to top of resources list if it's an update and the top isn't already visible
                if (updateUrl) {
                    var $output = $('.filtered-posts__output');
                    var outputTop = $output.offset().top;
                    var scrollTop = $(window).scrollTop();
                    var windowHeight = $(window).height();
                    if (outputTop < scrollTop || outputTop > (scrollTop + windowHeight)) {
                        $('html, body').animate({
                            scrollTop: outputTop - 40
                        }, 300);
                    }
                }
                updateFilterPills();
                updateFilterCounts();
                $wrapper.removeClass('loading');
            }
        });
    }

    // Pills UI
    function updateFilterPills() {
        let pills = [];
        // Taxonomies and ACF filters
        $(`${sidebarClass} input[type=checkbox]:checked`).each(function() {
            let label = $(this).parent().text().trim();
            let id = $(this).attr('id');
            pills.push(`<span class="filter-pill s5 me-3 mb-3" data-id="${id}">${label} <span role="img" aria-label="small gray icon with an X mark" class="remove-pill"></span></span>`);
        });
        // Keyword
        let keyword = $('.keyword-filter-search-field').val();
        if (keyword) {
            pills.push(`<span class="filter-pill s5 me-3 mb-3" data-id="keyword">${keyword} <span role="img" aria-label="small gray icon with an X mark" class="remove-pill"></span></span>`);
        }
        if (pills.length) {
            $('.filtered-posts__active-filters-pills').html(pills.join('') + ' <button class="clear-filters link-btn" style="text-wrap:nowrap;">Clear filters<span></span></button>').removeClass('d-none');
            $('.filtered-posts__active-bar').removeClass('d-none').addClass('d-flex');
        } else {
            $('.filtered-posts__active-filters-pills').addClass('d-none').empty();
            $('.filtered-posts__active-bar').removeClass('d-flex').addClass('d-none');
        }
    }

    // Update filter category counts
    function updateFilterCounts() {
        $(`${sidebarClass} .accordion-item`).each(function() {
            let $category = $(this);
            let count = $category.find('input[type=checkbox]:checked').length;
            if (count > 0) {
                $category.find('.mobile-filter-category-count').text(`(${count})`);
            } else {
                $category.find('.mobile-filter-category-count').text('');
            }
        });
    }

    // Checkbox filter change
    $(`${sidebarClass} input[type=checkbox]`).on('change', function() {
        updateResources(1, true);
    });

    // Sort order change
    $sortSelect.on( 'change', function() {
        updateResources( 1, true );
    } );

    // Show more/less filters
    $(document).on('click', '.show-more-filters', function() {
        var $btn = $(this);
        var $container = $btn.closest('.accordion-body');
        var $extras = $container.find('.extra-filter');
        if ($extras.is(':visible')) {
            $extras.addClass('d-none');
            $btn.html('Show more ' + $btn.data('filter').replace('_', ' ') + '<span></span>');
        } else {
            $extras.removeClass('d-none');
            $btn.html('Hide more ' + $btn.data('filter').replace('_', ' ') + '<span></span>');
        }
    });

    // Keyword search
    $('.keyword-filter-search-field').on('input', function() {
        updateResources(1, true);
    });

    // Pagination click
    $(document).on('click', '.pagination-link a', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var paged = 1;
        var match = href.match(/[?&]paged=(\d+)/);
        if (match && match[1]) {
            paged = match[1];
        } else {
            paged = $(this).text();
        }
        updateResources(paged, true);
    });

    // Remove filter pill
    $(document).on('click', '.remove-pill', function() {
        let pill = $(this).closest('.filter-pill');
        let id = pill.data('id');
        if (id === 'keyword') {
            $('.keyword-filter-search-field').val('');
        } else {
            $(`#${id}`).prop('checked', false);
        }
        updateResources(1, true);
    });

    // Clear filters
    $(document).on('click', '.clear-filters', function(e) {
        e.preventDefault();
        $(`${sidebarClass} input[type=checkbox]`).prop('checked', false);
        $('.keyword-filter-search-field').val('');
        updateResources(1, true);
    });

    // Function to get a fresh nonce via AJAX to bypass caching issues
    function getFreshNonce(callback) {
        $.post(PifFilterConfig.ajax_url, {
            action: 'get_post_filtering_nonce',
            actionType: ajaxAction
        }, function(response) {
            if (response.success && response.data.nonce) {
                window.PifFilterConfig.filter_nonce = response.data.nonce;
                callback(response.data.nonce);
            } else {
                callback(null);
            }
        });
    }

    // Set filters from URL, then load resources (but wait for nonce to be available in the window)
    getFreshNonce(function(nonce) {
        if (nonce) {
            setFiltersFromURL();
            updateResources(1, false);
        } else {
            console.log('Could not fetch security token. Please refresh.');
        }
    });

    // Offcanvas close on desktop (if needed)
    function closeOffcanvasIfDesktop() {
        if (window.innerWidth >= 1000) {
            var $offcanvas = $('.filtered-posts__offcanvas');
            if ($offcanvas.hasClass('show') && typeof bootstrap !== 'undefined') {
                var bsOffcanvas = bootstrap.Offcanvas.getInstance($offcanvas[0]);
                if (bsOffcanvas) bsOffcanvas.hide();
            }
        }
    }
    let resizeTimeout;
    $(window).on('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(closeOffcanvasIfDesktop, 150);
    });

});